
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $7b11b7a970952933$exports = {};
$7b11b7a970952933$exports = JSON.parse('{"meta":{"title":"UDT - Go Online for Just $9","description":"Deploy your websites in less than 60 seconds.","ogTitle":"UDT - Deploy your websites in less than 60 seconds.","ogDescription":"UDT Cloud builds, hosts, and manages business websites.","ogImage":"https://udith.pro","ogUrl":"https://udith.pro"},"brand":{"name":"UDT Cloud","summary":"Managed websites, hosting, security, and content support for small businesses that want the web handled."},"navigation":[{"label":"Home","href":"#home"},{"label":"How It Works","href":"#how-it-works"},{"label":"Pricing","href":"#pricing"},{"label":"Contact","href":"#contact"}],"cta":{"primary":{"label":"Get a Free Consultation","href":"#contact"},"secondary":{"label":"View Pricing","href":"#pricing"},"short":{"label":"Free consult","href":"#contact"}},"hero":{"eyebrow":"Managed websites, hosting, and care","heading":"Hassle-Free Web Hosting & Design","tagline":"We build your website, host it on lightning-fast servers, and manage it so you can focus on growing your business.","status":"Live managed hosting","image":{"name":"banner","extension":"png","alt":""},"stats":[{"value":"60s","label":"launch-ready deploys"},{"value":"24/7","label":"managed support"},{"value":"99.9%","label":"uptime focused"}]},"process":{"id":"how-it-works","heading":"How It Works","body":"Going live has never been this easy. See how we get your business online seamlessly.","steps":[{"label":"1. Your Idea","icon":"fa-desktop","tone":"pulse-blue","delay":""},{"label":"2. We Build & Host","icon":"fa-cloud","tone":"pulse-indigo","delay":"delay-1","gear":true},{"label":"3. You Go Live","icon":"fa-table-columns","tone":"pulse-rose","delay":"delay-3"}]},"pricing":{"id":"pricing","heading":"Simple Managed Website Plans","body":"Pick the level of care your business needs today. Every plan includes setup, hosting, security, and support.","plans":[{"name":"The Starter","price":"$29","cycle":"/month","badge":"Local Biz","description":"Perfect for local portfolios","features":["Done-for-you Setup","Monthly Backups","Free SSL Certificate","1 Hr Tech Support"],"popular":false},{"name":"The Business","price":"$79","cycle":"/month","badge":"Most Popular","description":"Best for growing companies","features":["Everything in Starter","Priority Support","Weekly Content Updates","Basic SEO Tools"],"popular":true},{"name":"Pro / E-Com","price":"$149","cycle":"/month","badge":"100% Managed","description":"For high-traffic stores","features":["High-Traffic Servers","Daily Backups","Unlimited Product Updates","Security & SEO"],"popular":false}]},"features":{"heading":"Your Online Presence, Fully Managed","body":"Focus on your business while we handle the technology behind your website.","items":[{"heading":"Done-For-You Setup","body":"Bring your idea, and our expert team will get your fast, beautiful website live within days. No coding required on your part.","icon":"fa-wand-magic-sparkles","image":"easy","contentAos":"fade-right","imageAos":"zoom-in-left"},{"heading":"Blazing Fast Speeds","body":"We use top-tier cloud enterprise servers to ensure your customers never have to wait for a page to load, increasing your sales and SEO.","icon":"fa-gauge-high","image":"fast","contentAos":"fade-up"},{"heading":"Iron-Clad Security","body":"Rest easy knowing your business is safe with free SSL certificates, daily backups, and top-of-the-line malware protection scanning.","icon":"fa-shield-halved","image":"wordpress","contentAos":"fade-up"},{"heading":"24/7 Managed Support","body":"Need a text change, an image updated, or a new page? Just email us, and our team handles all website updates for you efficiently.","icon":"fa-headset","image":"support","contentAos":"fade-left","imageAos":"fade-right"}]},"showcase":{"heading":"User-friendly Control Panel","body":"Track site health, updates, content requests, and performance from one clean managed dashboard.","image":{"name":"ipad","extension":"png","alt":""},"items":[{"heading":"Easy Start & Managed Updates","body":"Send updates in plain English and we handle the technical work, publishing, backups, and checks.","icon":"fa-rocket"},{"heading":"Staging, GIT & WP-CLI","body":"Advanced workflows stay available when your project needs safer releases and developer-level control.","icon":"fa-code-branch"},{"heading":"Dynamic Caching & More","body":"Built-in caching, SSL, uptime monitoring, and daily care keep your site fast after launch day.","icon":"fa-server"}]},"testimonial":{"heading":"What our Customers are Saying","body":"Business owners choose UDT Cloud because the website work finally stops feeling like a second job.","image":"testimonial","imageAlt":"A happy, smiling customer","quote":"UDT Cloud rebuilt our site, moved hosting, and now handles every update before I even have to chase it. It feels like having an in-house web team without hiring one.","author":"Maya Perera","organization":"Brightline Studio"},"contact":{"id":"contact","heading":"Let\'s Get Your Business Online","body":"Send us a message and our experts will get back to you within 24 hours.","eyebrow":"Free consultation","panelHeading":"Tell us what you need. We\u2019ll map the fastest way to launch.","panelBody":"Share your business goals, current website status, and timeline. We will reply with a practical next step, not a sales maze.","points":["Response within 24 hours","Hosting, design, and care in one team","Clear plan before any commitment"],"form":{"action":"#","method":"POST","button":"Send Message","fields":[{"label":"Name","type":"text","placeholder":"Your name","required":true},{"label":"Email","type":"email","placeholder":"you@company.com","required":true},{"label":"Project Details","type":"textarea","placeholder":"Tell us about your website, launch goal, or support needs...","rows":5,"required":true}]}},"footer":{"copyright":"Copyright 2026 Udith. All rights reserved.","backToTop":"Back to top","social":[{"label":"Twitter","href":"#","icon":"fa-twitter"},{"label":"LinkedIn","href":"#","icon":"fa-linkedin-in"},{"label":"Facebook","href":"#","icon":"fa-facebook-f"}],"columns":[{"heading":"Products","expanded":true,"links":[{"label":"Website Hosting","href":"#"},{"label":"Free Automated Wordpress","href":"#"},{"label":"Migrations","href":"#"}]},{"heading":"Company","links":[{"label":"About","href":"#"},{"label":"Affiliates","href":"#"},{"label":"Blog","href":"#"}]},{"heading":"Support","links":[{"label":"Contact","href":"#"},{"label":"Knowledge Base","href":"#"},{"label":"FAQ","href":"#"}]},{"heading":"Domains","links":[{"label":"Domain Checker","href":"#"},{"label":"Domain Transfer","href":"#"},{"label":"Free Domain","href":"#"}]}]},"whatsapp":{"href":"https://wa.me/1234567890","label":"Chat on WhatsApp"}}');


const $54b47fc030b7b21e$var$root = document.querySelector('#site-root');
var $f2c739318bc816a5$exports = {};
$f2c739318bc816a5$exports = import.meta.resolve("hmzIO");


var $fa4f028cab7ba486$exports = {};
$fa4f028cab7ba486$exports = import.meta.resolve("b5Jsc");


var $a0b11d1c8906a6f7$exports = {};
$a0b11d1c8906a6f7$exports = import.meta.resolve("hY2Oc");


var $a50669db30ebe883$exports = {};
$a50669db30ebe883$exports = import.meta.resolve("35BpC");


var $6d60650ec7d210fc$exports = {};
$6d60650ec7d210fc$exports = import.meta.resolve("9XrrW");


var $9c3c36598d00b4b9$exports = {};
$9c3c36598d00b4b9$exports = import.meta.resolve("2aVTj");


var $f3153e397a2a0422$exports = {};
$f3153e397a2a0422$exports = import.meta.resolve("3q67A");


var $cc279db8182158b1$exports = {};
$cc279db8182158b1$exports = import.meta.resolve("9drKr");


var $f97e26259e44ed70$exports = {};
$f97e26259e44ed70$exports = import.meta.resolve("aZ5f3");


var $00c440ac4423d4c1$exports = {};
$00c440ac4423d4c1$exports = import.meta.resolve("hby97");


var $57a6f3d2e6e38164$exports = {};
$57a6f3d2e6e38164$exports = import.meta.resolve("03zjw");


var $76bd6aab27962b9e$exports = {};
$76bd6aab27962b9e$exports = import.meta.resolve("cq4ik");


var $6cb1dcdb05ff7b11$exports = {};
$6cb1dcdb05ff7b11$exports = import.meta.resolve("9FRMm");


var $cb779ed37b86afc3$exports = {};
$cb779ed37b86afc3$exports = import.meta.resolve("8enWA");


var $46c36f6fa627937c$exports = {};
$46c36f6fa627937c$exports = import.meta.resolve("jX9Ip");


var $cd575be0de756553$exports = {};
$cd575be0de756553$exports = import.meta.resolve("c2872");


var $5f1b46f7f10b17e8$exports = {};
$5f1b46f7f10b17e8$exports = import.meta.resolve("5yAnS");


var $cf1ce016ad161078$exports = {};
$cf1ce016ad161078$exports = import.meta.resolve("5sL3Z");


var $04e769e36f8bcc3d$exports = {};
$04e769e36f8bcc3d$exports = import.meta.resolve("4VBZn");


var $70cfde4f8ea5e950$exports = {};
$70cfde4f8ea5e950$exports = import.meta.resolve("gceRd");


var $1fa4e76e9ad1d90b$exports = {};
$1fa4e76e9ad1d90b$exports = import.meta.resolve("ef508");


var $78c85809c22ac920$exports = {};
$78c85809c22ac920$exports = import.meta.resolve("hInDw");


var $9536e5932d20dd39$exports = {};
$9536e5932d20dd39$exports = import.meta.resolve("5zRId");


var $4cdf24f3721d8e18$exports = {};
$4cdf24f3721d8e18$exports = import.meta.resolve("7Hemg");


var $c141bd45d59add58$exports = {};
$c141bd45d59add58$exports = import.meta.resolve("ccdEr");


const $54b47fc030b7b21e$var$imageAssets = {
    banner: {
        png: new URL($f2c739318bc816a5$exports),
        png2x: new URL($fa4f028cab7ba486$exports),
        webp: new URL($a0b11d1c8906a6f7$exports),
        webp2x: new URL($a50669db30ebe883$exports)
    },
    easy: {
        jpg: new URL($6d60650ec7d210fc$exports),
        jpg2x: new URL($9c3c36598d00b4b9$exports),
        webp: new URL($f3153e397a2a0422$exports),
        webp2x: new URL($cc279db8182158b1$exports)
    },
    fast: {
        jpg: new URL($f97e26259e44ed70$exports),
        jpg2x: new URL($00c440ac4423d4c1$exports),
        webp: new URL($57a6f3d2e6e38164$exports),
        webp2x: new URL($76bd6aab27962b9e$exports)
    },
    ipad: {
        png: new URL($6cb1dcdb05ff7b11$exports),
        png2x: new URL($cb779ed37b86afc3$exports),
        webp: new URL($46c36f6fa627937c$exports),
        webp2x: new URL($cd575be0de756553$exports)
    },
    support: {
        jpg: new URL($5f1b46f7f10b17e8$exports),
        jpg2x: new URL($cf1ce016ad161078$exports),
        webp: new URL($04e769e36f8bcc3d$exports),
        webp2x: new URL($70cfde4f8ea5e950$exports)
    },
    testimonial: {
        jpg: new URL($1fa4e76e9ad1d90b$exports)
    },
    wordpress: {
        jpg: new URL($78c85809c22ac920$exports),
        jpg2x: new URL($9536e5932d20dd39$exports),
        webp: new URL($4cdf24f3721d8e18$exports),
        webp2x: new URL($c141bd45d59add58$exports)
    }
};
const $54b47fc030b7b21e$var$getImageAsset = (name, key)=>$54b47fc030b7b21e$var$imageAssets[name]?.[key] || '';
const $54b47fc030b7b21e$var$brandLogo = (gradientId)=>`
  <svg class="brand__mark" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="url(#${gradientId})"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <defs>
      <linearGradient id="${gradientId}" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#4f46e5" />
        <stop offset="100%" stop-color="#0ea5e9" />
      </linearGradient>
    </defs>
    <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"></path>
    <path d="M12 12v3"></path>
    <path d="M9 15h6"></path>
  </svg>
`;
const $54b47fc030b7b21e$var$brandLink = (gradientId)=>`
  <a class="brand" aria-label="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).brand.name}" href="#home">
    ${$54b47fc030b7b21e$var$brandLogo(gradientId)}
    <span class="brand__name">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).brand.name}</span>
  </a>
`;
const $54b47fc030b7b21e$var$responsivePicture = ({ name: name, extension: extension = 'jpg', alt: alt = '', className: className = '', aos: aos = '' })=>`
  <picture${aos ? ` data-aos="${aos}"` : ''}>
    <source type="image/webp" srcset="${$54b47fc030b7b21e$var$getImageAsset(name, 'webp')} 1x, ${$54b47fc030b7b21e$var$getImageAsset(name, 'webp2x')} 2x" />
    <source type="image/${extension}" srcset="${$54b47fc030b7b21e$var$getImageAsset(name, extension)} 1x, ${$54b47fc030b7b21e$var$getImageAsset(name, `${extension}2x`)} 2x" />
    <img${className ? ` class="${className}"` : ''} src="${$54b47fc030b7b21e$var$getImageAsset(name, extension === 'jpg' ? 'jpg2x' : extension)}" alt="${alt}" />
  </picture>
`;
const $54b47fc030b7b21e$var$renderHeader = ()=>`
  <header>
    <nav class="nav collapsible" aria-label="Primary navigation">
      <div class="nav__brand">${$54b47fc030b7b21e$var$brandLink('logo-gradient')}</div>
      <button class="nav__toggler" type="button" aria-label="Open navigation" aria-expanded="false">
        <i class="fa-solid fa-bars"></i>
      </button>
      <ul class="list nav__list collapsible__content">
        ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).navigation.map((item)=>`<li class="nav__item"><a href="${item.href}">${item.label}</a></li>`).join('')}
        <li class="nav__action">
          <button class="theme-toggle" type="button" aria-label="Toggle theme">
            <i class="fa-solid fa-moon" aria-hidden="true"></i>
          </button>
        </li>
        <li class="nav__action"><a href="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.short.href}" class="nav__cta">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.short.label}</a></li>
      </ul>
    </nav>
  </header>
`;
const $54b47fc030b7b21e$var$renderHero = ()=>`
  <section id="home" class="block block--dark hero">
    <div class="container hero__grid">
      <header class="block__header hero__content">
        <span class="eyebrow">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).hero.eyebrow}</span>
        <h1 data-aos="zoom-in-up" class="block__heading">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).hero.heading}</h1>
        <p class="hero__tagline">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).hero.tagline}</p>
        <div class="hero__actions" data-aos="fade-up" data-aos-delay="150">
          <a href="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.primary.href}" class="btn btn--accent">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.primary.label}</a>
          <a href="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.secondary.href}" class="btn btn--outline">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.secondary.label}</a>
        </div>
        <div class="hero__stats" aria-label="Service highlights">
          ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).hero.stats.map((stat)=>`<span><strong>${stat.value}</strong> ${stat.label}</span>`).join('')}
        </div>
      </header>
      <div class="hero__visual" data-aos="zoom-in">
        <div class="hero__status"><span class="hero__status-dot"></span>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).hero.status}</div>
        ${$54b47fc030b7b21e$var$responsivePicture({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).hero.image,
        className: 'hero__image'
    })}
      </div>
    </div>
  </section>
`;
const $54b47fc030b7b21e$var$renderProcess = ()=>`
  <section id="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).process.id}" data-aos="zoom-in-up" class="block section-shell section-process">
    <header class="block__header">
      <h2>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).process.heading}</h2>
      <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).process.body}</p>
    </header>
    <div class="code-animated-video">
      ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).process.steps.map((step, index)=>`
        ${index ? '<div class="cav-line"><div class="cav-particle' + (index === 2 ? ' delay-2' : '') + '"></div></div>' : ''}
        <div class="cav-node cav-bounce ${step.delay}">
          <div class="cav-icon-box ${step.tone}">
            <i class="fa-solid ${step.icon} fa-3x icon--primary" aria-hidden="true"></i>
            ${step.gear ? '<i class="fa-solid fa-gear cav-gear" aria-hidden="true"></i>' : ''}
          </div>
          <span class="cav-text">${step.label}</span>
        </div>
      `).join('')}
    </div>
  </section>
`;
const $54b47fc030b7b21e$var$renderPricing = ()=>`
  <section id="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).pricing.id}" data-aos="fade-up" class="block section-shell block-plans">
    <header class="block__header">
      <h2>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).pricing.heading}</h2>
      <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).pricing.body}</p>
    </header>
    <div class="grid grid--1x3 pricing-grid">
      ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).pricing.plans.map((plan, index)=>`
        <div class="plan${plan.popular ? ' plan--popular' : ''}" data-aos="fade-up" data-aos-delay="${[
            100,
            220,
            320
        ][index] || 100}">
          <div class="card ${plan.popular ? 'card--primary' : 'card--secondary'}">
            <header class="card__header">
              <h3 class="plan__name">${plan.name}</h3>
              <span class="plan__price">${plan.price}</span>
              <span class="plan__billing-cycle">${plan.cycle}</span>
              <span class="badge ${plan.popular ? 'badge--primary' : 'badge--secondary'} badge--small">${plan.badge}</span>
              <span class="plan__description">${plan.description}</span>
            </header>
            <div class="card__body">
              <ul class="list list--tick">
                ${plan.features.map((feature)=>`<li class="list__item">${feature}</li>`).join('')}
              </ul>
              <a href="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.primary.href}" class="btn btn--outline btn--block">Get Started</a>
            </div>
          </div>
        </div>
      `).join('')}
    </div>
  </section>
`;
const $54b47fc030b7b21e$var$renderFeatures = ()=>`
  <section class="block section-shell section-features">
    <header class="block__header">
      <h2>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).features.heading}</h2>
      <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).features.body}</p>
    </header>
    ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).features.items.map((feature)=>`
      <article class="grid grid--1x2 feature">
        <div class="feature__content" data-aos="${feature.contentAos}">
          <span class="icon-container">
            <i class="fa-solid ${feature.icon} fa-3x icon--primary" aria-hidden="true"></i>
          </span>
          <h3 class="feature__heading">${feature.heading}</h3>
          <p>${feature.body}</p>
          <a href="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).cta.primary.href}" class="link-arrow">Get Started</a>
        </div>
        ${$54b47fc030b7b21e$var$responsivePicture({
            name: feature.image,
            alt: '',
            className: 'feature__image',
            aos: feature.imageAos || ''
        })}
      </article>
    `).join('')}
  </section>
`;
const $54b47fc030b7b21e$var$renderShowcase = ()=>`
  <section class="block block--dark section-showcase">
    <header class="block__header">
      <h2>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.heading}</h2>
      <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.body}</p>
    </header>
    <div class="container grid grid--1x2">
      <picture data-aos="fade-right" class="block-showcase__image">
        <source type="image/webp" srcset="${$54b47fc030b7b21e$var$getImageAsset((0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.image.name, 'webp')} 1x, ${$54b47fc030b7b21e$var$getImageAsset((0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.image.name, 'webp2x')} 2x" />
        <source type="image/png" srcset="${$54b47fc030b7b21e$var$getImageAsset((0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.image.name, 'png')} 1x, ${$54b47fc030b7b21e$var$getImageAsset((0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.image.name, 'png2x')} 2x" />
        <img src="${$54b47fc030b7b21e$var$getImageAsset((0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.image.name, 'png')}" alt="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.image.alt}" />
      </picture>
      <ul class="list" data-aos="fade-up">
        ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).showcase.items.map((item)=>`
          <li>
            <div class="media">
              <div class="media__image"><i class="fa-solid ${item.icon} fa-2x icon--primary"></i></div>
              <div class="media__body">
                <h3 class="media__title">${item.heading}</h3>
                <p>${item.body}</p>
              </div>
            </div>
          </li>
        `).join('')}
      </ul>
    </div>
  </section>
`;
const $54b47fc030b7b21e$var$renderTestimonial = ()=>`
  <section class="block section-shell section-testimonial" data-aos="zoom-in">
    <header class="block__header">
      <h2>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.heading}</h2>
      <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.body}</p>
    </header>
    <div class="container">
      <div class="card testimonial">
        <div class="grid grid--1x2">
          <div class="testimonial__image">
            <img src="${$54b47fc030b7b21e$var$getImageAsset((0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.image, 'jpg')}" alt="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.imageAlt}" />
            <span class="icon-container icon-container--accent">
              <i class="fa-solid fa-quote-left fa-sm icon--white"></i>
            </span>
          </div>
          <blockquote class="quote">
            <p class="quote__text">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.quote}</p>
            <footer>
              <div class="media">
                <div class="media__image"><i class="fa-solid fa-minus fa-2x quote__line"></i></div>
                <div class="media__body">
                  <h3 class="media__title quote__author">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.author}</h3>
                  <p class="quote__organization">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).testimonial.organization}</p>
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  </section>
`;
const $54b47fc030b7b21e$var$renderField = (field)=>{
    if (field.type === 'textarea') return `
      <label class="field">
        <span>${field.label}</span>
        <textarea class="input" placeholder="${field.placeholder}" rows="${field.rows || 5}"${field.required ? ' required' : ''}></textarea>
      </label>
    `;
    return `
    <label class="field">
      <span>${field.label}</span>
      <input type="${field.type}" class="input" placeholder="${field.placeholder}"${field.required ? ' required' : ''} />
    </label>
  `;
};
const $54b47fc030b7b21e$var$renderContact = ()=>{
    const [nameField, emailField, detailsField] = (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.form.fields;
    return `
    <section id="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.id}" class="block section-shell section-contact">
      <header class="block__header">
        <h2>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.heading}</h2>
        <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.body}</p>
      </header>
      <div class="contact-panel">
        <aside class="contact-panel__content">
          <span class="eyebrow">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.eyebrow}</span>
          <h3>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.panelHeading}</h3>
          <p>${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.panelBody}</p>
          <ul class="contact-points list">
            ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.points.map((point)=>`<li><i class="fa-solid fa-check" aria-hidden="true"></i> ${point}</li>`).join('')}
          </ul>
        </aside>
        <div class="card contact-card">
          <form class="contact-form" action="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.form.action}" method="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.form.method}">
            <div class="contact-form__row">
              ${$54b47fc030b7b21e$var$renderField(nameField)}
              ${$54b47fc030b7b21e$var$renderField(emailField)}
            </div>
            ${$54b47fc030b7b21e$var$renderField(detailsField)}
            <button type="submit" class="btn btn--primary btn--block">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).contact.form.button}</button>
          </form>
        </div>
      </div>
    </section>
  `;
};
const $54b47fc030b7b21e$var$renderFooter = ()=>`
  <footer class="block block--dark footer">
    <div class="container grid footer__sections">
      <div class="footer__brand">
        <div class="footer__logo">${$54b47fc030b7b21e$var$brandLink('footer-logo-gradient')}</div>
        <p class="footer__summary">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).brand.summary}</p>
        <div class="footer__social" aria-label="Social links">
          ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).footer.social.map((item)=>`<a href="${item.href}" aria-label="${item.label}"><i class="fa-brands ${item.icon}" aria-hidden="true"></i></a>`).join('')}
        </div>
      </div>
      ${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).footer.columns.map((column)=>`
        <section class="collapsible${column.expanded ? ' collapsible--expanded' : ''} footer__section">
          <div class="collapsible__header">
            <h2 class="collapsible__heading footer__heading">${column.heading}</h2>
            <i class="fa-solid fa-chevron-down collapsible__chevron"></i>
          </div>
          <div class="collapsible__content">
            <ul class="list">
              ${column.links.map((link)=>`<li><a href="${link.href}">${link.label}</a></li>`).join('')}
            </ul>
          </div>
        </section>
      `).join('')}
    </div>
    <div class="container footer__bottom">
      <p class="footer__copyright">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).footer.copyright}</p>
      <a href="#home">${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).footer.backToTop}</a>
    </div>
  </footer>
`;
const $54b47fc030b7b21e$var$renderWhatsapp = ()=>`
  <a href="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).whatsapp.href}" target="_blank" rel="noreferrer" aria-label="${(0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).whatsapp.label}" class="whatsapp-float">
    <svg width="35" height="35" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c-.003 1.396.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
    </svg>
  </a>
`;
const $54b47fc030b7b21e$var$updateMeta = ()=>{
    document.title = (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).meta.description);
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).meta.ogTitle);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).meta.ogDescription);
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).meta.ogImage);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', (0, (/*@__PURE__*/$parcel$interopDefault($7b11b7a970952933$exports))).meta.ogUrl);
};
const $54b47fc030b7b21e$var$setNavExpanded = (nav, isExpanded)=>{
    nav.classList.toggle('collapsible--expanded', isExpanded);
    const toggler = nav.querySelector('.nav__toggler');
    const icon = toggler?.querySelector('i');
    toggler?.setAttribute('aria-expanded', String(isExpanded));
    toggler?.setAttribute('aria-label', isExpanded ? 'Close navigation' : 'Open navigation');
    icon?.classList.toggle('fa-bars', !isExpanded);
    icon?.classList.toggle('fa-xmark', isExpanded);
};
const $54b47fc030b7b21e$var$initCollapsibles = ()=>{
    document.querySelectorAll('.collapsible').forEach((item)=>{
        item.addEventListener('click', function(e) {
            const toggler = e.target.closest('.nav__toggler');
            const header = e.target.closest('.collapsible__header');
            if (!toggler && !header) return;
            const isExpanded = !this.classList.contains('collapsible--expanded');
            if (this.classList.contains('nav')) {
                $54b47fc030b7b21e$var$setNavExpanded(this, isExpanded);
                return;
            }
            this.classList.toggle('collapsible--expanded', isExpanded);
        });
    });
    document.querySelectorAll('.nav__list a').forEach((link)=>{
        link.addEventListener('click', ()=>{
            const nav = link.closest('.nav');
            if (nav) $54b47fc030b7b21e$var$setNavExpanded(nav, false);
        });
    });
};
const $54b47fc030b7b21e$var$initThemeToggle = ()=>{
    const themeToggleBtn = document.querySelector('.theme-toggle');
    const themeIcon = themeToggleBtn?.querySelector('i');
    const currentTheme = localStorage.getItem('theme');
    if (currentTheme && themeIcon) {
        document.documentElement.setAttribute('data-theme', currentTheme);
        if (currentTheme === 'dark') themeIcon.classList.replace('fa-moon', 'fa-sun');
    }
    themeToggleBtn?.addEventListener('click', function(e) {
        e.preventDefault();
        const theme = document.documentElement.getAttribute('data-theme');
        if (theme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'light');
            localStorage.setItem('theme', 'light');
            themeIcon?.classList.replace('fa-sun', 'fa-moon');
        } else {
            document.documentElement.setAttribute('data-theme', 'dark');
            localStorage.setItem('theme', 'dark');
            themeIcon?.classList.replace('fa-moon', 'fa-sun');
        }
    });
};
const $54b47fc030b7b21e$var$renderSite = ()=>{
    $54b47fc030b7b21e$var$updateMeta();
    $54b47fc030b7b21e$var$root.innerHTML = [
        $54b47fc030b7b21e$var$renderHeader(),
        $54b47fc030b7b21e$var$renderHero(),
        $54b47fc030b7b21e$var$renderProcess(),
        $54b47fc030b7b21e$var$renderPricing(),
        $54b47fc030b7b21e$var$renderFeatures(),
        $54b47fc030b7b21e$var$renderShowcase(),
        $54b47fc030b7b21e$var$renderTestimonial(),
        $54b47fc030b7b21e$var$renderContact(),
        $54b47fc030b7b21e$var$renderFooter(),
        $54b47fc030b7b21e$var$renderWhatsapp()
    ].join('');
    $54b47fc030b7b21e$var$initCollapsibles();
    $54b47fc030b7b21e$var$initThemeToggle();
    window.AOS?.refreshHard();
};
$54b47fc030b7b21e$var$renderSite();


//# sourceMappingURL=repo.62ecf990.js.map
